import { RequestQuery } from 'common';

import type { OrdersOverviewQueryParams } from './types';

export const getOrdersOverviewQueryKeyPrefix = () =>
  ['orders', 'ordersOverview'] as const;

export type OrdersOverviewQueryKeyPrefixType = ReturnType<
  typeof getOrdersOverviewQueryKeyPrefix
>;

export type OrdersOverviewQueryKeyType = [
  ...OrdersOverviewQueryKeyPrefixType,
  RequestQuery<OrdersOverviewQueryParams> | undefined,
];

export const getOrdersOverviewQueryKey = (
  query?: RequestQuery<OrdersOverviewQueryParams>,
): OrdersOverviewQueryKeyType => [...getOrdersOverviewQueryKeyPrefix(), query];
